/* eslint-disable import/prefer-default-export */
/* eslint-disable import-helpers/order-imports */

import { useEffect, useState } from 'react';
import io from 'socket.io-client-v2';

const getSaflSocketUrl = () => (
  process.env.REACT_APP_SAFL_SOCKET_URL || 'http://localhost:6379'
);

let sharedSocket = null;
let subscribers = 0;

const acquireSocket = () => {
  if (!sharedSocket) {
    sharedSocket = io(getSaflSocketUrl(), {
      transports: ['websocket', 'polling'],
      forceNew: false,
    });
  }

  subscribers += 1;
  return sharedSocket;
};

const releaseSocket = () => {
  subscribers = Math.max(0, subscribers - 1);

  if (subscribers === 0 && sharedSocket) {
    sharedSocket.disconnect();
    sharedSocket = null;
  }
};

const useSaflSocket = () => {
  const [socket] = useState(() => acquireSocket());

  useEffect(() => () => {
    releaseSocket();
  }, []);

  return socket;
};

export default useSaflSocket;
